import React, { useContext } from "react";
import { getPricePresentationAsElement, PresentationType } from "../../../../services/pricing";
import { ProductBuilderPrice } from "./ProductBuilderPrice";
import { Placeholder } from "../../../../pluginsInfrastructure/PluginRegistryTypes";
import PluginPlaceholder from "../../../../pluginsInfrastructure/PluginPlaceholder";

import "../styles/ClientSidePriceRenderer.scss";
import { BffDataContext } from "../../../../contexts/BffDataContextProvider";
import { ProductContext } from "../../../../contexts/ProductContextProvider";
import { PricingContext } from "../../../../contexts/PricingContext";
import { PageStaticDataContext } from "../../../../contexts/PageStaticDataContextProvider";

interface ClientSidePriceRendererProps {}

const ClientSidePriceRenderer = (props: ClientSidePriceRendererProps) => {
  const { prices } = useContext(BffDataContext);
  const { locale } = useContext(PageStaticDataContext);
  const { selectedQuantity, clientSideStateInitialized } = useContext(ProductContext);
  const { vatInclusivity } = useContext(PricingContext);

  const [hasMounted, setHasMounted] = React.useState(false);

  // Client side pricing
  const pricing = prices ? prices[`${selectedQuantity}`] : undefined;

  const clientSidePricingElement = pricing
    ? getPricePresentationAsElement({
        price: pricing,
        quantity: selectedQuantity,
        locale,
        presentationType: PresentationType.STARTING_AT,
        vatInclusivity,
      })
    : undefined;

  const isPricingReady = !!(hasMounted && clientSidePricingElement && clientSideStateInitialized);

  React.useEffect(() => {
    setHasMounted(true);
  }, []);

  // TO DO -- move product builder price with experiment into its own plugin for a placeholder after pricing
  return (
    <PluginPlaceholder placeholderType={Placeholder.Pricing}>
      <ProductBuilderPrice
        isPricingReady={isPricingReady}
        pricePresentationElement={clientSidePricingElement}
      />
    </PluginPlaceholder>
  );
};

export default ClientSidePriceRenderer;
